export function bytesToHex(
    byteArray: Uint8Array
) {
    const hexParts = [];

    for (let i = 0; i < byteArray.length; ++i) {
        const hex = byteArray[i].toString(16);
        const paddedHex = ('00' + hex).slice(-2);
        hexParts.push(paddedHex);
    }

    return hexParts.join('');
}

/**
 *  It is a decoding method for bytesToHex output
 * @param hexString hexString expected to be string of hex chars
 * @return Uint8Array decoded to bytes representation of Uint8Array of chars
 **/

export function hexToBytes (
    hexString: string = ''
): Uint8Array {
    const unit8Parts = [];
    let index = 0;
    while (index < hexString.length) {
        unit8Parts.push(parseInt(hexString.substring(index, index + 2), 16));
        index += 2;
    }
    return new Uint8Array(unit8Parts);
}
